
let threeDManagerConstants;
{
  const GLOBAL_UTILS = require('../../../../shared/util/GlobalUtils'),
        LOGGING_CONSTANTS = require('../../../../shared/constants/LoggingConstants'),
        LOGGING_LEVELS = LOGGING_CONSTANTS.loggingLevels;

  let _settingsDefinition = {
    show: {
      value: false,
      setting: 'show',
      desc: 'Show / hide the scene',
      type: 'boolean'
    },
    showTransition: {
      value: '1s'
    },
    groundPlaneVisibility: {
      value: false,
      setting: 'groundPlaneVisibility',
      desc: 'Show / hide the ground plane',
      type: 'boolean'
    },
    render: {
      devicePixelRatio: {
        value: 1.0
      },
      shadows: {
        value: false,
        setting: 'render.shadows',
        desc: 'Enable / disable shadows for rendering',
        type: 'boolean'
      },
    },
    camera: {
      far: {
        value: 100
      },
      fov: {
        value: 45,
      },
      near: {
        value: 0.01
      },
    },
    material: {
      environmentMap: {
        value: 'default',
        setting: 'material.environmentMap',
        desc: 'Name of the environment map to use, or an array of 6 URLs making up the cube mapped environment map (px, nx, pz, nz, py, ny)', 
        type: (v) => (typeof v === 'string' || (GLOBAL_UTILS.isArrayOfType(v, 'string') && v.length === 6))
      }
    }
  };

  function _hasSubValue(def) {
    if (typeof def === 'object') {
      for (let key in def) {
        if (key === 'value')
          return true;
        if (_hasSubValue(def[key]))
          return true;
      }
    }

    return false;
  }

  function _convert(def, global) {
    for (let key in def) {
      if (key === 'value') {
        if (_hasSubValue(def[key])) {
          return global = _convert(def[key], global);
        } else {
          return def[key];
        }
      } else if (key !== 'setting' && key !== 'desc' && key !== 'type') {
        global[key] = {};
        global[key] = _convert(def[key], global[key]);
      }
    }
    return global;
  }

  let _defaultSettings = {};
  _convert(_settingsDefinition, _defaultSettings);

  threeDManagerConstants = {
    settingsDefinition: _settingsDefinition,
    defaultSettings: _defaultSettings,
    loggingLevels: LOGGING_LEVELS
  };
}

module.exports = require('../../../../shared/util/GlobalUtils').deepCopy(threeDManagerConstants);
